const Placeholder = ({ text }) => {
  return (
    <div className="p-6 text-slate-400 text-sm border rounded-xl bg-white">
      {text || "Content will appear here."}
    </div>
  );
};

export default Placeholder;
